import * as graphql from '@treams/treams-network';
import { Paragraph } from '@treams/treams-ui';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

function Description() {
	return (
		<>
			<Paragraph mb={2}>
				SCIM (System for Cross-domain Identity Management) is een gestandaardiseerde manier om
				identiteitsgegevens uit je bestaande identiteit-beheersysteem te exporteren naar andere
				systemen, zoals Treams.
			</Paragraph>
			<Paragraph mb={2}>
				Mits je huidige identiteit-beheersysteem SCIM ondersteunt, kan het middels SCIM automatisch
				gebruikersaccounts maken, wijzigen en archiveren in Treams. Dit maakt het managen van
				gebruikersaccounts een stuk simpeler.
			</Paragraph>
		</>
	);
}

export default function Scim() {
	return (
		<ProductLayout
			id="scim"
			description={<Description />}
			type={graphql.ConnectorType.Scim}
			headerImageURL="https://assets.ontreams.com/marketplace/SCIM.jpg"
			translate={translate}
			price={125}
			documentationLink="https://treams.notion.site/Uitleg-Koppelen-met-SCIM-1537d567742a802587abe3c888857f25?pvs=4"
		/>
	);
}

export function ScimTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="scim"
			title="SCIM"
			description="Vereenvoudigd beheer van gebruikersaccounts"
			logoImageURL="https://assets.ontreams.com/marketplace/SCIM.jpg"
			selected={props.selected}
		/>
	);
}
